import { useTranslation } from 'react-i18next';
import { COMMERCIAL_SITE } from '@connexio/shared/constants';
import { cn } from '@/lib/utils';
import { MARKETING_INLINE_LINK_CLASS } from './Section';
import styles from './ContactEmailNote.module.css';

/**
 * The contact address as visible text next to a mailto button, so a visitor without a
 * mail app can still copy it.
 */
export function ContactEmailNote({ className }: { className?: string }) {
  const { t } = useTranslation('marketing');
  const email = COMMERCIAL_SITE.contactEmail;
  if (!email) return null;

  return (
    <p className={cn(styles.text, 'text-body-m', className)}>
      {t('cta.emailUs')}{' '}
      <a href={`mailto:${email}`} className={MARKETING_INLINE_LINK_CLASS}>
        {email}
      </a>
    </p>
  );
}
